import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import { S } from '../regureStyles';
import GenerateCommissionsDialog from './GenerateCommissionsDialog';
import useCommissionsFunctions from './useCommissionsFunctions';
import Header from './Header';
import Chips from './Chips';
import Tabs from './Tabs';
import OverviewTab from './OverviewTab';
import SlidingScale from './SlidingScale';
import PlansTab from './PlansTab';
import StatementView from './StatementView';

const ALLOWED_ROLES = ['admin', 'systemAdmin', 'orgAdmin', 'claimsManager', 'broker', 'riskCarrier', 'complianceOfficer'];

const CommissionsScreen = () => {
  const { t } = useTranslation();
  const c = useCommissionsFunctions();

  if (c.userRole && !ALLOWED_ROLES.includes(c.userRole)) {
    return (
      <AppLayout>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh', gap: 12 }}>
          <h2 style={{ color: S.textPrimary, margin: 0 }}>{t('screens.commissions.accessDenied')}</h2>
          <p style={{ color: S.textSecondary, textAlign: 'center', maxWidth: 400 }}>
            {t('screens.commissions.notAuthorized')}
          </p>
        </div>
      </AppLayout>
    );
  }

  if (c.loading) {
    return (
      <AppLayout>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 60 }}>
          <div style={{ width: 36, height: 36, border: '3px solid #e2e8f0', borderTopColor: '#7c3aed', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      {c.showGenerate && (
        <GenerateCommissionsDialog
          periodOptions={c.periodOptions}
          defaultPeriod={c.period}
          onClose={() => c.setShowGenerate(false)}
          onGenerated={c.fetchSummary}
        />
      )}

      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Header fetchCommissions={c.fetchCommissions} />

        <Chips totalEarned={c.totalEarned} totalPaid={c.totalPaid} totalOutstanding={c.totalOutstanding} />

        {c.viewMode === 'statement' ? (
          <div style={{ flex: 1, overflowY: 'auto', padding: '24px 32px' }}>
            <StatementView
              brokerId={c.statementBrokerId}
              period={c.period}
              isAdmin={c.isAdmin}
              onClose={c.closeStatement}
            />
          </div>
        ) : (
          <>
            <Tabs TABS={c.TABS} activeTab={c.activeTab} setActiveTab={c.setActiveTab} />
            <div style={{ flex: 1, overflowY: 'auto', padding: '24px 32px' }}>
              {c.activeTab === 'overview' && (
                <OverviewTab
                  portfolio={c.portfolio}
                  search={c.search}
                  setSearch={c.setSearch}
                  filtered={c.filtered}
                  period={c.period}
                  setPeriod={c.setPeriod}
                  periodOptions={c.periodOptions}
                  isAdmin={c.isAdmin}
                  onGenerateClick={() => c.setShowGenerate(true)}
                  onLinkPoliciesClick={c.linkPolicies}
                  linkingPolicies={c.linkingPolicies}
                  onBrokerClick={c.openStatement}
                />
              )}

              {c.activeTab === 'plans' && c.isAdmin && (
                <PlansTab plans={c.plans} onRefresh={c.fetchPlans} />
              )}

              {c.activeTab === 'sliding-scale' && <SlidingScale />}
            </div>
          </>
        )}
      </div>
    </AppLayout>
  );
};

export default CommissionsScreen;
